import React, { useContext, useEffect } from 'react'
import { Container } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { GeneralContext } from '../../context/'
import MaterialsManager from './components/MaterialsManager'

const Index = () => {
    const { setBreadcrumb } = useContext(GeneralContext)
    useEffect(() => setBreadcrumb({ parent: 'Inventario', parentLink: '/materials', item: 'Materiales' }), []) // eslint-disable-line
    return <div className="page-content"><Container fluid><h2>Materiales</h2><MaterialsManager /></Container></div>
}
export default withRouter(Index)
